module.exports = __webpack_public_path__ + "img/slide_2.11999e73.jpg";